export function GetLinkForOldMyAccount(baseUrl: string, language: string) {
    return language === "en" || language === undefined ? `${baseUrl}/user` : `${baseUrl}/${language}/user`
}

export function GetLinkForMyCompany(baseUrl: string, language: string) {
    return language === "en" || language === undefined ? `${baseUrl}/manage-company` : `${baseUrl}/${language}/manage-company`
}

export function GetLinkForOldMyCompany(baseUrl: string, language: string) {
    return language === "en" || language === undefined ? `${baseUrl}/user/login?destination=manage-company` : `${baseUrl}/${language}/user/login?destination=manage-company`
}

export function GetLinkForDwAcademy(baseUrl: string, language: string) {
    return `${baseUrl}/ilp/pages/personalarea.jsf?menuId=1404&locale=${getLanguageForDwAcademy(language)}&showbundlekeys=false#!/users/@self/contents/current?limit=10`
}

function getLanguageForDwAcademy(language: string) {
    switch (language) {
        case "es":
            return "es-ES";
        case "de":
            return "de-DE";
        case "fr":
            return "fr-FR";
        default:
            return "en-GB";
    }
}